<template>
  <b-card style="border: 1px solid #0000001a">
    <b-col cols="12" class="d-flex justify-content-between align-items-center">
      <h5 class="font-weight-bolder">Email Templates</h5>
      <b-button
        variant="primary"
        rel="noopener noreferrer"
        href="https://customer.io"
        target="_blank"
      >
        <feather-icon icon="ExternalLinkIcon" class="mr-1" />
        Click here to go to Customer IO
      </b-button>
    </b-col>

    <!-- Audience Filter -->
    <b-col cols="12" class="mt-1">
      <div class="d-flex align-items-center" style="gap: 8px">
        <span class="font-weight-bold" style="font-size: 13px">Show:</span>
        <b-button
          v-for="opt in audienceOptions"
          :key="opt"
          size="sm"
          :variant="audienceFilter === opt ? 'primary' : 'outline-secondary'"
          @click="audienceFilter = opt"
        >
          {{ opt }}
        </b-button>
      </div>
    </b-col>

    <b-col cols="12" class="mt-1">
      <b-table
        :items="filteredItems"
        :fields="fields"
        responsive
        thead-class="text-no-wrap"
      >
        <template #cell(type)="data">
          <b-badge :variant="typeVariant(data.item.type)">
            {{ data.item.type }}
          </b-badge>
        </template>

        <template #cell(audience)="data">
          <b-badge :variant="audienceVariant(data.item.audience)">
            {{ data.item.audience }}
          </b-badge>
        </template>

        <!-- STATUS -->
        <template #cell(status)="data">
          <b-badge
            :variant="data.item.status === 'Active' ? 'success' : 'warning'"
          >
            {{ data.item.status }}
          </b-badge>
        </template>
        <template #cell(actions)>
          <div class="d-flex align-items-center">
            <b-button size="sm" variant="link" class="p-0 mr-1 text-primary">
              <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button size="sm" variant="link" class="p-0 mr-1 text-warning">
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button size="sm" variant="link" class="p-0 mr-1 text-success">
              <feather-icon icon="CopyIcon" />
            </b-button>
            <b-button size="sm" variant="link" class="p-0 text-danger">
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-col>
  </b-card>
</template>

<script>
import { BCard, BButton, BTable, BBadge, BRow, BCol } from "bootstrap-vue";
export default {
  components: {
    BCard,
    BButton,
    BTable,
    BBadge,
    BRow,
    BCol,
  },
  data() {
    return {
      audienceFilter: "Both",
      audienceOptions: ["Both", "Internal", "External"],
      fields: [
        { key: "name", label: "TEMPLATE NAME" },
        { key: "subject", label: "SUBJECT" },
        { key: "type", label: "TYPE" },
        { key: "audience", label: "AUDIENCE" },
        { key: "status", label: "STATUS" },
        { key: "usage", label: "USAGE" },
        { key: "lastModified", label: "LAST MODIFIED" },
        { key: "actions", label: "ACTIONS" },
      ],
      items: [
        {
          name: "Welcome Email",
          subject: "Welcome to UPC Betting Platform",
          type: "Welcome",
          audience: "External",
          status: "Active",
          usage: 1247,
          lastModified: "2025-01-05",
        },
        {
          name: "Deposit Confirmation",
          subject: "Deposit Successful - ${{amount}} Added",
          type: "Deposit",
          audience: "External",
          status: "Active",
          usage: 892,
          lastModified: "2025-01-03",
        },
        {
          name: "Withdrawal Confirmation",
          subject: "Withdrawal Processed - ${{amount}}",
          type: "Withdrawal",
          audience: "External",
          status: "Active",
          usage: 456,
          lastModified: "2025-01-02",
        },
        {
          name: "Weekly Promotions",
          subject: "This Week's Best Betting Offers",
          type: "Promotion",
          audience: "Both",
          status: "Active",
          usage: 5678,
          lastModified: "2025-01-01",
        },
        {
          name: "Security Alert",
          subject: "Security Alert - Login from New Device",
          type: "Security",
          audience: "Internal",
          status: "Active",
          usage: 234,
          lastModified: "2024-12-28",
        },
        {
          name: "Password Reset",
          subject: "Reset Your Password",
          type: "Security",
          audience: "External",
          status: "Draft",
          usage: 0,
          lastModified: "2024-12-25",
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      if (this.audienceFilter === "Both") return this.items;
      return this.items.filter(
        (i) => i.audience === this.audienceFilter || i.audience === "Both"
      );
    },
  },
  methods: {
    typeVariant(type) {
      switch (type) {
        case "Welcome":
          return "success";
        case "Deposit":
          return "primary";
        case "Withdrawal":
          return "warning";
        case "Promotion":
          return "info";
        case "Security":
          return "danger";
        default:
          return "secondary";
      }
    },
    audienceVariant(audience) {
      switch (audience) {
        case "Internal":
          return "primary";
        case "External":
          return "success";
        case "Both":
          return "secondary";
        default:
          return "secondary";
      }
    },
  },
};
</script>
